import { Splide } from "@splidejs/splide";

const carousel = () => {
  const targetElms = document.getElementsByClassName('js-sliderVoice');
  if(targetElms.length === 0) return;
  
  for(const targetElm of targetElms) {
    let splideInstance = null;
    const breakpoint = 768;
    
    const initSplide = () => {
      const isSP = window.innerWidth < breakpoint;
      
      if (isSP && !splideInstance) {
        // SPでSplideを起動
        const speed = 400;
        let options = {
          type: "loop",
          speed: speed,
          rewindSpeed: speed,
          perPage: 1,
          gap: "1.5rem",
          arrows: true,
          pagination: true,
          focus: 'center',
          reduceMotion: {
            speed: speed,
            rewindSpeed: speed,
          }
        };
        
        // data属性でカスタマイズ
        if(targetElm.dataset.speed) {
          options.speed = parseInt(targetElm.dataset.speed);
          options.rewindSpeed = parseInt(targetElm.dataset.speed);
          options.reduceMotion.speed = parseInt(targetElm.dataset.speed);
          options.reduceMotion.rewindSpeed = parseInt(targetElm.dataset.speed);
        }
        
        if(targetElm.dataset.gap) {
          options.gap = targetElm.dataset.gap;
        }
        
        if(targetElm.dataset.perpage) {
          options.perPage = parseInt(targetElm.dataset.perpage);
        }
        
        splideInstance = new Splide(targetElm, options);
        splideInstance.mount();
      } else if (!isSP && splideInstance) {
        // PCでSplideを破棄
        splideInstance.destroy();
        splideInstance = null;
      }
    };
    
    // 初期化
    initSplide();
    
    // リサイズ時に再判定（デバウンス付き）
    let resizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initSplide();
      }, 250);
    });
  }
};

const init = () => {
  carousel();
};

export default init;